var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edu"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"id":"timeline-edu"}},_vm._l((_vm.data),function(item,index){return _c('TimeLineWrapper',{key:index,attrs:{"data":item.data()}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }